import { useClasses } from 'modules/jogador/classes/useClasses';
import { PillTabs } from 'shared/components/ui/PillTabs';
import { PlanCard } from 'modules/jogador/classes/components/PlanCard';
import { SessionRow } from 'modules/jogador/classes/components/SessionRow';
import { UpgradeOptionRow } from 'modules/jogador/classes/components/UpgradeOptionRow';
import { CLASS_TABS } from 'modules/jogador/classes/content';
import { AsyncSection } from 'shared/components/ui/LoadingState';
import { ClassesSkeleton } from 'modules/jogador/classes/components/ClassesSkeleton';

export function ClassesPage() {
  const { activeTab, setActiveTab, plan, upcomingSessions, upgradeOptions, isLoading, error } = useClasses();

  return (
    <section className="mx-auto max-w-2xl px-4 py-8">
      <h1 className="font-heading text-2xl font-bold text-ink">Aulas</h1>

      <div className="mt-4">
        <PillTabs options={CLASS_TABS} value={activeTab} onChange={setActiveTab} />
      </div>

      <AsyncSection
        isLoading={isLoading}
        error={error}
        loadingLabel="Carregando aulas..."
        skeleton={
          <ClassesSkeleton />
        }
      >
        {activeTab === 'meu-plano' ? (
          <div className="mt-6 flex flex-col gap-8">
            <PlanCard plan={plan} />

            <div>
              <h2 className="text-sm font-semibold uppercase tracking-wide text-ink-secondary">
                Próximas sessões
              </h2>
              <div className="mt-3 flex flex-col gap-2">
                {upcomingSessions.map((session) => (
                  <SessionRow key={session.id} session={session} />
                ))}
              </div>
            </div>

            <div>
              <h2 className="text-sm font-semibold uppercase tracking-wide text-ink-secondary">
                Upgrade
              </h2>
              <div className="mt-3 flex flex-col gap-2">
                {upgradeOptions.map((option) => (
                  <UpgradeOptionRow key={option.id} option={option} />
                ))}
              </div>
            </div>
          </div>
        ) : (
          <p className="mt-6 text-sm text-ink-secondary">
            {activeTab === 'pacotes' ? 'Pacotes' : 'Aulas avulsas'} em breve.
          </p>
        )}
      </AsyncSection>
    </section>
  );
}
